export default __webpack_public_path__ + "static/media/lantern-left.59ed8997.webp";